export const INITIALIZE_BIZ_TRIP_FORM = {
  type: "One Way",
  from: "",
  to: "",
  departureDate: "",
  departureTime: "",
  returnDate: "",
  returnTime: "",
  preferredAirlines: [
    { label: "Srilankan Airlines", selected: false },
    { label: "Nepal Airlines", selected: false },
    { label: "Bangladesh Airlines", selected: false },
    { label: "Air India", selected: false },
    { label: "Egypt Air", selected: false },
    { label: "Philippines Airlines", selected: false },
    { label: "Indigo", selected: false },
    { label: "Turkish Airlines", selected: false },
    { label: "Royal Jordanian", selected: false },
    { label: "Air Cairo", selected: false },
    { label: "Emirates Airlines", selected: false },
    { label: "Kuwait Airways", selected: false },
    { label: "Pakistan Airlines", selected: false },
    { label: "Middle East Airlines", selected: false },
    { label: "Fly Dubai", selected: false },
    { label: "Saudi Airlines", selected: false },
    { label: "Qatar Airways", selected: false },
    { label: "Gulf Air", selected: false },
    { label: "Etihad Airlines", selected: false },
  ],
  flightType: "Direct Flight",
  paymentType: "Company Paid",
  travelClass: "",
  costBorneBy: "",
  projectId: "",
  costCenter: "",
  businessRequirement: [],
};

export const FORM_ERROR_INITIALIZATION = [
  {
    from: "",
    to: "",
    date: "",
    time: "",
    flightType: "",
    paymentType: "",
    travelClass: "",
    preferredHotel: "",
    perDiemAmount: "",
    carType: "",
    businessRequirement: {},
  },
];

export const FLIGHT_TYPE = ["Direct Flight", "Indirect Flight"];
export const PAYMENT_TYPE = ["Company Paid", "Self Paid"];
export const TRAVEL_TYPE = ["Business Class", "Economy"];
export const LEAVE_TYPES = [
  { id: "Business", name: "Business" },
  { id: "Casual", name: "Casual" },
];
